import { ChevronLeft, ChevronRight, Check } from "lucide-react";
import { Button } from "./ui/button";
import { Aurora } from "@/components/motion/Aurora";
import RevealTitle from "@/components/motion/RevealTitle";

export default function WizardLayout({
  title,
  step,
  totalSteps,
  stepLabel,
  onBack,
  onNext,
  nextLabel,
  nextDisabled,
  isLastStep,
  loading,
  children,
  hideNav,
}) {
  const progress = ((step + 1) / totalSteps) * 100;
  return (
    <div className="aurora-page relative isolate min-h-screen bg-ivory pb-32">
      <Aurora variant="light" fixed />
      <header className="sticky top-0 z-30 aurora-host aurora-host--dark border-b border-white/10">
        <Aurora variant="dark" />
        <div className="container-x py-4">
          <div className="flex items-center justify-between mb-3">
            <button
              onClick={onBack}
              disabled={step === 0}
              className="text-ivory/80 disabled:opacity-30"
              data-testid="wizard-back-icon"
            >
              <ChevronLeft className="h-6 w-6" />
            </button>
            <div className="text-overline">{stepLabel}</div>
            <div className="text-sm text-ivory tabular-nums">
              {step + 1} / {totalSteps}
            </div>
          </div>
          <div className="h-2 w-full bg-white/20 rounded-full overflow-hidden">
            <div
              className="h-full bg-terracotta transition-all duration-500 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </header>

      <main key={step} className="container-x py-6 mv-step">
        {title && (
          <RevealTitle key={title} as="h2" immediate className="text-2xl sm:text-3xl font-bold tracking-tight text-charcoal mb-2">
            {title}
          </RevealTitle>
        )}
        {children}
      </main>

      {!hideNav && (
        <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-sand shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-40">
          <div className="container-x flex justify-between items-center gap-3">
            <Button
              variant="outline"
              onClick={onBack}
              disabled={step === 0 || loading}
              className="border-2 border-forest-deep text-forest-deep hover:bg-sand-light"
              data-testid="wizard-back-btn"
            >
              <ChevronLeft className="h-4 w-4 mr-1" /> Atrás
            </Button>
            <Button
              onClick={onNext}
              disabled={nextDisabled || loading}
              className="bg-forest-deep text-white hover:bg-forest flex-1 sm:flex-none sm:px-8"
              data-testid="wizard-next-btn"
            >
              {loading ? (
                "Procesando..."
              ) : isLastStep ? (
                <>
                  Finalizar <Check className="h-4 w-4 ml-1" />
                </>
              ) : (
                <>
                  {nextLabel || "Siguiente"} <ChevronRight className="h-4 w-4 ml-1" />
                </>
              )}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
